import { Container } from '@plone/components';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import PDFBlockView from '@eeacms/volto-pdf-block/components/manage/PDFViewer/BlockView';
import {
  extractFileType,
  formatFileSize,
} from 'cmuberlandia-portal/utils/fileHelpers';
import type { BlobData } from 'cmuberlandia-portal/types/content';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import downloadIcon from '@plone/volto/icons/download.svg';

interface FileViewerProps {
  file: BlobData;
  header?: string;
}

const FileViewer = ({ file, header }: FileViewerProps) => {
  const contentType = file['content-type'];
  const isPDF = contentType === 'application/pdf';
  const downloadUrl = file?.download && flattenToAppURL(file.download);
  const fileType = extractFileType(file);
  const fileInfo = fileType
    ? `${fileType} / ${formatFileSize(file.size)}`
    : `${formatFileSize(file.size)}`;
  return (
    <Container narrow className="file-wrapper">
      {header && <h2 className="headline">{header}</h2>}
      {isPDF && <PDFBlockView data={{ url: downloadUrl }} />}
      {downloadUrl && (
        <p className="fileDownload">
          <a
            href={downloadUrl}
            className="fileDownloadLink"
            title="Download file"
          >
            <Icon name={downloadIcon} />
            <span className="fileName">{file.filename}</span>
          </a>{' '}
          <span className="fileInfo">({fileInfo})</span>
        </p>
      )}
    </Container>
  );
};

export default FileViewer;
